import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  input,
  output,
} from '@angular/core';
import { ModalService } from 'src/app/_services/modal.service';
import { ButtonComponent } from '../../buttons/button/button.component';
import { ChangeRequest } from 'src/app/_models/requests';
import { DatePipe } from '@angular/common';
import { Role, RoleEnum } from 'src/app/_models/role';
import { Laboratory } from 'src/app/_models/laboratory';
import { MatIconButtonComponent } from '../../buttons/mat-icon-button/mat-icon-button.component';
import { FormatRolePipe } from 'src/app/_helpers/format-role.pipe';

@Component({
    selector: 'app-approvals-request-modal',
    templateUrl: './approvals-request-modal.component.html',
    styleUrls: ['./approvals-request-modal.component.scss'],
    imports: [ButtonComponent, DatePipe, MatIconButtonComponent, FormatRolePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalsRequestModalComponent implements OnInit, OnDestroy {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly modalService = inject(ModalService);
  private readonly element: HTMLElement;

  Role = Role;
  RoleEnum = RoleEnum;

  /** Change request object (required)*/
  request = input<ChangeRequest>();

  /** Modal id (required) */
  id = input<string>();

  /** Modal title (required) */
  titleText = input<string>();

  /** Primary button text (required) */
  primaryButtonText = input<string>();

  /** Primary button id (required) */
  primaryButtonId = input<string>();

  /** Secondary button text (required) */
  secondaryButtonText = input<string>();

  /** Secondary button id (required) */
  secondaryButtonId = input<string>();

  /** Is the modal processing (optional, default: false) */
  isProcessing = input<boolean>(false);

  /** Whether user can close modal (optional, default: true) */
  allowClose = input<boolean>(true);

  /** Output event for clicked button on modal */
  approvalButtonClicked = output<number>();

  /** Output event for clicked button on modal */
  rejectButtonClicked = output<number>();

  constructor() {
    const el = this.el;
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    if (this.allowClose()) {
      // Close modal on background click
      this.element.addEventListener('click', (e: Event) => {
        const target = e.target as HTMLElement;
        if (target.className === 'modal--backdrop') {
          this.close();
        }
      });
    }

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  approvalButtonEventHandler(valueEmitted: number): void {
    this.approvalButtonClicked.emit(valueEmitted);
  }

  rejectButtonEventHandler(valueEmitted: number): void {
    this.rejectButtonClicked.emit(valueEmitted);
  }

  getLabList(userLabs: Laboratory[]): string {
    // Get the names of the labs the user is associated with
    // by iterating through the userLaboratories array
    return userLabs.map((lab) => lab.laboratoryName).join(', ');
  }

  // open modal
  open(): void {
    this.element.style.display = 'block';
  }

  // close modal
  close(): void {
    // Reset valdiation text value and close modal
    this.element.style.display = 'none';
  }

  // Remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id());
    this.element.remove();
  }
}
